import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { InteractiveText } from "../../Text";
import { ButtonComponent } from "./Button.styles";
var defaultProps = {
    type: "button",
    iconAlignment: "left",
    size: "large",
    variant: "primary",
    fullWidth: false,
    loading: false,
    disabled: false
};
/** Renders a button or a link looking like a button. */ var Button = function(_param) {
    var children = _param.children, icon = _param.icon, iconAlignment = _param.iconAlignment, size = _param.size, variant = _param.variant, fullWidth = _param.fullWidth, loading = _param.loading, disabled = _param.disabled, className = _param.className, textId = _param.textId, props = _object_without_properties(_param, [
        "children",
        "icon",
        "iconAlignment",
        "size",
        "variant",
        "fullWidth",
        "loading",
        "disabled",
        "className",
        "textId"
    ]);
    var isDisabled = disabled === true;
    var isSmallButton = size === "small";
    var isSecondaryButton = variant === "secondary";
    var isFullWidth = fullWidth === true;
    return /*#__PURE__*/ _jsxs(ButtonComponent, _object_spread_props(_object_spread({
        as: props.href ? "a" : undefined
    }, props), {
        type: props.href ? undefined : props.type,
        disabled: props.href ? undefined : disabled,
        iconAlignment: iconAlignment,
        isDisabled: isDisabled,
        isSmallButton: isSmallButton,
        isSecondaryButton: isSecondaryButton,
        isFullWidth: isFullWidth,
        "aria-busy": loading ? "true" : undefined,
        "aria-disabled": props.href && isDisabled ? "true" : undefined,
        className: className,
        children: [
            icon,
            /*#__PURE__*/ _jsx(InteractiveText, {
                id: textId,
                inline: true,
                textColor: "current",
                size: isSmallButton ? "small" : "normal",
                children: children
            })
        ]
    }));
};
Button.defaultProps = defaultProps;
export { Button };
